module.exports = __webpack_public_path__ + "static/media/hot.0f1e3845.svg";